<template>
    <div class="page-wrapper">
        <Header></Header>
        <div class="page-content-centered">
    <div class="container">
        <div class="form-container">
            <b-card id="card" v-if="!isAuthenticated">
                <div style="height: 90px; margin-bottom: 10px">
                    <p style="font-family: 'Mansalva', cursive; font-weight: bold; font-size: 60px;">Login</p>
                </div>
                <ul style="padding: 0; text-align: left">
                    <li style="color: red; list-style: none; display: block; width: 100%;" v-bind:key="error" v-for="error in errors">{{ error }}</li>
                </ul>
                <b-form-input id="username" style="margin-top: 10px" v-model="name" type="text" v-bind:placeholder="usernamePlaceholder"></b-form-input>
                <div style="height: 25px;"></div>
                        <b-form-input id="password" v-model="password" type="password" v-bind:placeholder="passwordPlaceholder"></b-form-input>
                <div style="height: 10px;"></div>
            </b-card>
            <b-card id="cardtwo" v-if="isAuthenticated">
                <div class="message">
                    <p id="message-greeting">Hi {{ name }}!
                        <br/> </p>
                    <p id="message-text">We're glad to have you here!</p>
                </div>
            </b-card>
        </div>
        <div v-if="!loading" class="container-button" v-on:keyup.enter="enterFunction">
            <b-button v-if="!isAuthenticated" @click="enterFunction" type="submit" style="max-width: 300px;
            display: block; margin: 20px auto;" pill variant="primary" class="btn btn-lg btn-block">Sign In</b-button>
            <b-button v-if="isAuthenticated" @click="logoutUser()" type="submit" style="max-width: 300px;
            display: block; margin: 20px auto;" pill variant="danger" class="btn btn-lg btn-block">Sign Out</b-button>
        </div>
        <div v-else class="container-button" style="min-width: 48%; max-width: 48%; height: 100px; display: inline-block">
            <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center">
                <b-spinner style="max-width: 300px;" variant= "light" label="Uploading ..."></b-spinner>
            </div>
        </div>
    </div>

    </div>
        <div style="height: 15px"></div>
        <Footer></Footer>
    </div>
</template>

<script>
    import {isEmpty, isNil, isEqual} from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";

    export default {
        name: 'LoginPage',
        components: {Footer, Header },
        data() {
            return {
                errors: [],
                name: '',
                password: '',
                loading: false,
                error: false,
                usernamePlaceholder: 'username',
                passwordPlaceholder: 'password',


            };
        },
        computed: {
            ...mapGetters(['admin', 'adminName', 'isAuthenticated', 'snack']),
        },
        methods: {
            ...mapActions(['login', 'logout']),
            loginUser() {
                if (!isEmpty(this.name) && !isEmpty(this.password)) {
                    if (!this.isAuthenticated) {
                        this.login({ name: this.name, password: this.password })
                            .then((response) => {
                                if (response) {
                                    this.$router.push('/');
                                } else {
                                    this.error = true;
                                    this.errors.push('Username and/or Password incorrect.');
                                    console.log("Error were sorry")
                                }
                            });
                    }
                }
            },
            logoutUser() {
                if (this.isAuthenticated) {
                    this.logout().then(() => {
                        this.$router.push('/');
                    });
                }
            },
            enterFunction() {
                if (this.isAuthenticated) {
                    this.logoutUser();
                } else {
                    this.loading = true;
                    if (this.checkForm()) {
                        this.loginUser();
                    }
                    this.loading = false;
                }
            },
            checkForm: function () {
                this.error = false;
                this.errors = [];
                if (this.name && this.password && this.password.length >= 4) {
                    let elem = document.getElementById('username');
                    elem.style.border = "1px solid black";
                    let elem2 = document.getElementById('password');
                    elem2.style.border = "1px solid black";
                    return true;
                }

                if (!this.name) {
                    this.usernamePlaceholder ='Name required.';
                    let elem = document.getElementById('username');
                    elem.style.border = "1px solid red";
                    this.error = true;
                } else {
                    let elem = document.getElementById('username');
                    elem.style.border = "1px solid black";
                }
                if (!this.password || this.password.length < 4) {
                    if (!this.password) {
                        this.passwordPlaceholder = 'Password required.';
                        let elem = document.getElementById('password');
                        elem.style.border = "1px solid red";
                        this.error = true;
                    }
                    if (this.password && this.password.length < 4) {
                        this.password = '';
                        this.passwordPlaceholder = 'Password must be at least 4 characters long.';
                        let elem = document.getElementById('password');
                        elem.style.border = "1px solid red";
                        this.error = true;
                    }
                } else {
                    let elem = document.getElementById('password');
                    elem.style.border = "1px solid black";
                }
            }
        },
        mounted() {
            window.scrollTo(0,0);
            window.addEventListener('keyup', event => {
                if (event.keyCode === 13) {
                    this.enterFunction()
                }
            });
            if (!isEqual(this.adminName, '') && !isNil(localStorage.getItem('admin'))) {
                this.name = this.adminName;
            }
        },
    };
</script>
<style scoped>
    .page-wrapper {
        min-height: 100vh;
    }

    .page-content-centered {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 80vh;
        height: auto;
    }

    .container-button {
        width: 100%;
    }

    .form-container {
        max-width: 600px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
    }

    .message {
        font-family: 'Mansalva', cursive;
        font-weight: bold;
        color: black;
    }

    #card {
        width: 500px;
    }

    #cardtwo {
        width: 500px;
    }

    #message-greeting {
        font-size: 60px;
    }

    #message-text {
        font-size: 35px;
    }

    div.card-body {
        padding-bottom: 0!important;
    }

    @media only screen and (max-width: 500px) {
        #card {
            width: 95vw;
        }

        #cardtwo {
            width: 95vw;
        }

        #message-greeting {
            font-size: 35px;
        }

        #message-text {
            font-size: 20px;
        }
    }


</style>
